/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocklowenabled2Inputs */

const vi_stocklowenabled2 = /** @type {(inputs: Stocklowenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho sắp hết`)
};

/**

* @param {Stocklowenabled2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const stocklowenabled2 = /** @type {((inputs?: Stocklowenabled2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocklowenabled2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocklowenabled2(inputs)
});
export { stocklowenabled2 as "stockLowEnabled" }